import { parseCSSSelector } from './selectorRegex';
export const ERROR = {
  OK: 'OK',
  EMPTY: 'EMPTY',
  INVALID: 'INVALID',
  UNSUPPORTED: 'UNSUPPORTED',
  CALL_SUPPORT: 'CALL_SUPPORT'
};

export default function validate (cssSelector) {
  let rulesetNodes;
  if (!cssSelector) {
    return ERROR.EMPTY;
  }

  if (cssSelector.indexOf('[class] [class] [class] [class]') > -1) {
    return ERROR.CALL_SUPPORT;
  }
  try {
    document.querySelectorAll(cssSelector);
  } catch (e) {
    return ERROR.INVALID;
  }

  try {
    rulesetNodes = parseCSSSelector(cssSelector);
  } catch (e) {
    return ERROR.UNSUPPORTED;
  }

  console.log(rulesetNodes);
  return ERROR.OK;
}



/** WEBPACK FOOTER **
 ** ./src/utils/validate.js
 **/